// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MemberInformation_wrapper__2GLSb","wrapper__title":"MemberInformation_wrapper__title__lV_R0"};